function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M50.965 58.252C36.33 70.74 2.014 49.6 2 30.403 1.986 11.207 36.088-4.898 50.928 5.016c14.84 9.915 14.674 40.749.037 53.236z",
  fill: "#1FA956"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31 40l-8-8m0 0l8-8m-8 8h19",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgProgramsSliderLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUwLjk2NTQgNTguMjUyMkMzNi4zMjkzIDcwLjczOTggMi4wMTM4IDQ5LjU5OTYgMiAzMC40MDMzQzEuOTg2MjEgMTEuMjA3MSAzNi4wODgzIC00Ljg5ODUgNTAuOTI3OCA1LjAxNjA1QzY1Ljc2NzMgMTQuOTMwNiA2NS42MDE1IDQ1Ljc2NDcgNTAuOTY1NCA1OC4yNTIyWiIgZmlsbD0iIzFGQTk1NiIvPgo8cGF0aCBkPSJNMzEgNDBMMjMgMzJNMjMgMzJMMzEgMjRNMjMgMzJINDIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgProgramsSliderLeftArrow as ReactComponent };